<template>
    <div>

    </div>
</template>

<script>
export default {
    mounted() {
    },
    data () {
        return {
            value: [],
        }
    },
    methods: {
        selectTag (tagList) {
        }
    },
    props: {
        tags_prop: {
            type: Array,
            required: true
        },
        name_input_prop:{
            type: String,
            required: true
        },
    }
}
</script>

<style>
</style>
